import React, { Suspense } from "react";
import { useHostValue } from "../Contexts/HostContext";
import { ChatStates } from "../Interfaces/Stores/IHostStore";
var Chat = /*#__PURE__*/React.lazy(function () {
  return import("./Chat");
});
function ChatLoader() {
  var state = useHostValue()[0];
  if (state.chat.running !== ChatStates.NEW) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null, "Loading...")
  }, /*#__PURE__*/React.createElement(Chat, null));
}
export default ChatLoader;